import script from "./baseView.vue?vue&type=script&setup=true&lang=js"
export * from "./baseView.vue?vue&type=script&setup=true&lang=js"

import "./baseView.vue?vue&type=style&index=0&id=544bb648&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-544bb648"]])

export default __exports__